import script from "./TressTheMyPagesOrderHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressTheMyPagesOrderHistory.vue?vue&type=script&lang=ts&setup=true"

import "./TressTheMyPagesOrderHistory.vue?vue&type=style&index=0&id=164ad90e&lang=scss"

const __exports__ = script;

export default __exports__